"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const batch_http_1 = require("@apollo/client/link/batch-http");
const http_1 = require("@apollo/client/link/http");
const isomorphic_unfetch_1 = (0, tslib_1.__importDefault)(require("isomorphic-unfetch"));
const getAuthHeaders_1 = (0, tslib_1.__importDefault)(require("../../auth/getAuthHeaders"));
const retry_1 = require("@apollo/client/link/retry");
const client_1 = require("@apollo/client");
const onNetworkError_1 = (0, tslib_1.__importDefault)(require("../onNetworkError"));
const getUri_1 = (0, tslib_1.__importDefault)(require("./getUri"));
exports.default = (options) => {
    const customFetch = async (uri, fetchOptions) => {
        const authHeaders = (0, getAuthHeaders_1.default)(fetchOptions.body, options.getHeaders);
        for (const key of Object.keys(authHeaders)) {
            fetchOptions.headers[key] = authHeaders[key];
        }
        try {
            const finalUri = (0, getUri_1.default)(uri, fetchOptions);
            const fetchFunction = options.customFetch ? options.customFetch : isomorphic_unfetch_1.default;
            const result = await fetchFunction(finalUri, fetchOptions);
            return result;
        }
        catch (error) {
            console.warn('GraphQL request error:', error);
            throw error;
        }
    };
    const retryLink = new retry_1.RetryLink({
        attempts(count, operation, error) {
            if (!options.canRetry)
                return false;
            if (typeof options.canRetry === 'function')
                return options.canRetry(count, operation, error);
            if (error && error.result && error.result.error === 'AuthError') {
                if (error.result.message.toLowerCase().includes('jwt')) {
                    return false;
                }
                else if (error.result.message === 'nonceIsInvalid') {
                    return count < 20;
                }
                else {
                    console.log('got an auth error and will retry');
                    (0, onNetworkError_1.default)({ networkError: error });
                    return count < 5;
                }
            }
            if (count > 10)
                return false;
            console.log('Received a request with error. Will retry', error);
            return !!error;
        },
        delay: {
            initial: 250,
            max: Infinity,
            jitter: true
        }
    });
    const httpLink = options.batch
        ? new batch_http_1.BatchHttpLink({
            uri: options.endpointURL + '/graphql',
            fetch: customFetch,
            batchInterval: options.batchInterval
        })
        : new http_1.HttpLink({
            uri: options.endpointURL + '/graphql',
            fetch: customFetch
        });
    return client_1.ApolloLink.from([retryLink, httpLink]);
};
